import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback, useState } from 'react';
import { axiosBeelineRequest } from '@beef/utils';
import { CAPTCHA_URL, getJsonFromFile } from "../utils";
var TIMEOUT_DISABLED = 3000;
var API_URL = '/api/LandingFormEmail/Send/';
var ERROR_MESSAGE = 'Что-то пошло не так';
// TODO заменить setting на settings
export var useFormLayout = function useFormLayout(_ref) {
  var landing = _ref.landing,
    setting = _ref.setting,
    onClick = _ref.onClick;
  var _useState = useState('none'),
    _useState2 = _slicedToArray(_useState, 2),
    modalType = _useState2[0],
    setModalType = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    captchaSrc = _useState4[0],
    setCaptchaSrc = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    captchaKey = _useState6[0],
    setCaptchaKey = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    captchaValue = _useState8[0],
    setCaptchaValue = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    formValues = _useState10[0],
    setFormValues = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDisabledCaptcha = _useState12[0],
    setDisabledCaptcha = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isSuccessSending = _useState16[0],
    setSuccessSending = _useState16[1];
  var fetchCaptcha = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, _yield$getJsonFromFil, captcha, captchakey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return axiosBeelineRequest({
            method: 'get',
            originalResponse: true,
            url: CAPTCHA_URL,
            withCredentials: true,
            responseType: 'blob'
          });
        case 3:
          response = _context.sent;
          if (response.headers['content-type'] === 'image/gif') {
            setCaptchaSrc(URL.createObjectURL(response.data));
          }
          if (!(response.headers['content-type'] === 'application/json')) {
            _context.next = 13;
            break;
          }
          _context.next = 8;
          return getJsonFromFile(response.data);
        case 8:
          _yield$getJsonFromFil = _context.sent;
          captcha = _yield$getJsonFromFil.captcha;
          captchakey = _yield$getJsonFromFil.captchakey;
          setCaptchaSrc("data:image/png;base64,".concat(captcha));
          setCaptchaKey(captchakey);
        case 13:
          _context.next = 18;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 15]]);
  })), []);
  var handleChange = useCallback(function (e) {
    var value = e.target.value;
    setCaptchaValue(value);
  }, []);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setSuccessSending(false);
            setFormValues(values);
            setCaptchaValue('');
            setCaptchaKey('');
            setModalType('captcha');
            fetchCaptcha();
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleCaptchaSubmit = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var bodyFormData, response, responseValidate, _responseValidate$Err;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          bodyFormData = new FormData();
          setDisabledCaptcha(true);
          formValues.forEach(function (item) {
            var value = item.value,
              key = item.key;
            if (Array.isArray(value)) {
              value.forEach(function (file, index) {
                bodyFormData.append("".concat(key).concat(index), file);
              });
            } else {
              var processedValue = typeof value === 'boolean' ? "".concat(value) : value;
              bodyFormData.append(key, processedValue || '');
            }
          });
          bodyFormData.append('captcha', captchaValue);
          if (captchaKey) {
            bodyFormData.append('_captcha_key', captchaKey);
          }
          _context3.prev = 5;
          _context3.next = 8;
          return axiosBeelineRequest({
            method: 'post',
            originalResponse: true,
            url: API_URL,
            params: {
              landing: landing,
              settings: setting
            },
            data: bodyFormData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        case 8:
          response = _context3.sent;
          responseValidate = typeof response === 'string' ? JSON.parse(response) : response.data;
          if (responseValidate !== null && responseValidate !== void 0 && responseValidate.IsSucceeded) {
            setModalType('success');
            setSuccessSending(true);
            onClick === null || onClick === void 0 ? void 0 : onClick();
          } else {
            setError((responseValidate === null || responseValidate === void 0 ? void 0 : (_responseValidate$Err = responseValidate.Error) === null || _responseValidate$Err === void 0 ? void 0 : _responseValidate$Err.ErrorMessage) || ERROR_MESSAGE);
          }
          _context3.next = 16;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](5);
          setModalType('error');
        case 16:
          _context3.prev = 16;
          setFormValues([]);
          setTimeout(function () {
            setDisabledCaptcha(false);
          }, TIMEOUT_DISABLED);
          setCaptchaValue('');
          fetchCaptcha();
          return _context3.finish(16);
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[5, 13, 16, 22]]);
  })), [captchaValue, captchaKey, formValues, landing, onClick, setting, fetchCaptcha]);
  return {
    handleSubmit: handleSubmit,
    modal: {
      type: modalType,
      data: {
        onClose: function onClose() {
          return setModalType('none');
        },
        onClick: fetchCaptcha,
        onSubmitCaptcha: handleCaptchaSubmit,
        onChange: handleChange,
        captchaSrc: captchaSrc,
        captchaValue: captchaValue,
        error: error,
        isDisabledCaptcha: isDisabledCaptcha,
        isSuccessSending: isSuccessSending
      }
    }
  };
};